import React, {Component} from 'react';
import {connect} from 'react-redux';
import {completeMessage} from '../actions';
import { showToast } from '../actions/toastBus';
import { LuMail, LuPhone, LuCheck, LuX, LuCalendarClock, LuReply } from 'react-icons/lu';
import '../stylesheet/ListItem.css';

// Small at-a-glance card (who + when) - click it to see the actual message
// in a popup, same modal shell used across the rest of admin (Skills,
// Analytics, etc). "Checked" now lives inside that popup and removes the
// message from Firebase entirely, which is what actually clears it from
// this index.
class ListItem extends Component {
  state = { modalOpen: false, modalClosing: false, completing: false };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    window.clearTimeout(this._modalTimer);
  }

  handleKeyDown = (event) => {
    if (event.key === 'Escape') this.closeModal();
  };

  openModal = () => {
    document.addEventListener('keydown', this.handleKeyDown);
    this.setState({ modalOpen: true, modalClosing: false });
  };

  closeModal = () => {
    if (!this.state.modalOpen) return;
    document.removeEventListener('keydown', this.handleKeyDown);
    this.setState({ modalClosing: true });
    window.clearTimeout(this._modalTimer);
    // Match the exit-animation timing (see .message-modal-* in
    // ListItem.css) before actually unmounting.
    this._modalTimer = window.setTimeout(() => {
      this.setState({ modalOpen: false, modalClosing: false });
    }, 320);
  };

  handleComplete = () => {
    const { messageId, completeMessage } = this.props;
    this.setState({ completing: true });
    Promise.resolve(completeMessage(messageId))
      .then(() => {
        showToast('Message marked as checked', 'success');
        this.closeModal();
      })
      .catch((error) => {
        console.error('Error completing message:', error);
        this.setState({ completing: false });
        showToast('Could not update this message - please try again.', 'error');
      });
  };

  render() {
    const { message } = this.props;
    const { modalOpen, modalClosing, completing } = this.state;
    const date = message.createdAt.substr(4, 11);
    const time = message.createdAt.substr(16, 8);
    // Opens whatever mail app the admin has set as default, pre-addressed
    // to the visitor and pre-filled - "from my mail id" just means it's
    // whichever account that app is signed into, same as replying to any
    // other email.
    const mailtoHref = `mailto:${message.email}`
      + `?subject=${encodeURIComponent(`Re: your message to Mohamed Sajfan`)}`
      + `&body=${encodeURIComponent(`Hi ${message.name},\n\n`)}`;

    return (
      <>
        <div
          className="message-card"
          onClick={this.openModal}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), this.openModal())}
          role="button"
          tabIndex={0}
          aria-haspopup="dialog"
          aria-label={`View message from ${message.name}`}
        >
          <span className="message-card-date"><LuCalendarClock /> {date} <span className="message-card-time">{time}</span></span>
          <h3 className="message-card-name">{message.name}</h3>
          <div className="message-card-meta">
              <span><LuMail /> {message.email}</span>
              <span><LuPhone /> {message.contact}</span>
          </div>
        </div>

        {modalOpen && (
          <div
            className={`message-modal-backdrop${modalClosing ? ' is-closing' : ''}`}
            onClick={this.closeModal}
          >
            <div className="message-modal-panel" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
              <button
                type="button"
                className="message-modal-close"
                onClick={this.closeModal}
                aria-label="Close"
              >
                <LuX />
              </button>
              <span className="message-modal-eyebrow">
                  <LuCalendarClock /> {date} <span className="message-modal-time">{time}</span>
              </span>
              <h3 className="message-modal-heading">{message.name}</h3>
              <div className="message-modal-meta">
                  <a className="message-modal-link" href={`mailto:${message.email}`}>
                      <LuMail /> {message.email}
                  </a>
                  <a className="message-modal-link" href={`tel:${message.contact}`}>
                      <LuPhone /> {message.contact}
                  </a>
              </div>
              <p className="message-modal-text">{message.message}</p>
              <div className="message-modal-actions">
                  <a className="message-modal-respond" href={mailtoHref}>
                      <LuReply /> Respond by email
                  </a>
                  <button
                    type="button"
                    className="message-modal-done"
                    onClick={this.handleComplete}
                    disabled={completing}
                  >
                    <LuCheck /> {completing ? 'Marking as checked...' : 'Checked'}
                  </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default connect(null, {completeMessage})(ListItem);
